import React from 'react';

import CommonContainer from "../../containers/Common";

interface Props {
  meganetLensMasterId: number,
}

export default ((props) => {

  const commonContainer = CommonContainer.useContainer();
  const maker = commonContainer.getMaker(props.meganetLensMasterId);

  return (
    <>{maker ? maker.makerName : ''}</>
  );
}) as React.FC<Props>;
